export const decodeBase64Object = (str: string) => JSON.parse(atob(str)) as { [key: string]: string };
